import * as React from "react";
import { Context } from "./_context";
export const UptrendIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5 3.25a.75.75 0 0 1 .75.75v7.5h-1.5V5.81l-7.72 7.72-1.06-1.06 7.72-7.72H5v-1.5h7.5Z", fill: "currentColor" }));
  return iconset[size];
};
UptrendIcon.iconId = "pkQd7c";
